module.exports = __webpack_public_path__ + "img/index_m1.ea19de1a.jpg";